module.exports = __webpack_public_path__ + "media/megamenu/Mosaics-1fb0f7cf.jpg";